import React from "react";
import { REPLY_PREVIEW_MAX } from "./constants";

// =====================================================
// REPLY PREVIEW
// The small quoted-message strip. Used in two places:
//   • inside a message bubble (the quote above a reply) — clickable to jump
//     to the original message;
//   • above the composer while you're drafting a reply — with a ✕ to cancel.
// Purely presentational; the parent supplies the snapshot + handlers.
// =====================================================

const previewText = (reply) => {
  if (!reply) return "";
  if (reply.text) {
    return reply.text.length > REPLY_PREVIEW_MAX
      ? reply.text.slice(0, REPLY_PREVIEW_MAX) + "…"
      : reply.text;
  }
  const ft = reply.fileType || "";
  if (ft.startsWith("image")) return "📷 Photo";
  if (ft.startsWith("video")) return "🎥 Video";
  if (ft.startsWith("audio")) return "🎤 Voice message";
  return "📎 Attachment";
};

function ReplyPreview({ reply, onClick, onCancel, compact = false }) {
  if (!reply) return null;
  return (
    <div
      className={`reply-preview ${compact ? "reply-preview-compact" : ""} ${
        onClick ? "reply-clickable" : ""
      }`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <div className="reply-bar" />
      <div className="reply-body">
        <span className="reply-author">
          {reply.senderName || "Message"}
        </span>
        <span className="reply-snippet">{previewText(reply)}</span>
      </div>
      {onCancel && (
        <button
          type="button"
          className="reply-cancel"
          onClick={(e) => {
            e.stopPropagation();
            onCancel();
          }}
          aria-label="Cancel reply"
        >
          ✕
        </button>
      )}
    </div>
  );
}

export default React.memo(ReplyPreview);
